export default class CompanyLatestOfferNumbers {
	constructor(year, latestOfferNr, suggestedNextOfferNr) {
		this.year = parseInt(year, 10);
		this.latestOfferNr = latestOfferNr;
		this.suggestedNextOfferNr = suggestedNextOfferNr;
	}
}
